import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

interface FErrorLabelProps {
  message: string | undefined | null;
}

const FErrorLabel: FC<FErrorLabelProps> = ({ message }) => {
  const { t } = useTranslation();
  if (!message) return null;

  return (
    <div className="text-error pl-1">
      <p>{t(message)}</p>
    </div>
  );
};
export default FErrorLabel;
